import { useState } from "react";
import { useLocation } from "react-router-dom";
import { RotateCcw } from "lucide-react";
import { clearSelections } from "../lib/selections";

/**
 * One control that puts the visitor back to a blank sheet: every remembered choice cleared, and the page
 * reopened without the selections carried in its address.
 */
export const StartAgain = ({ label = "Start again", to, className = "", testId = "start-again" }) => {
  const { pathname } = useLocation();
  const [done, setDone] = useState(false);

  // One replace, not a navigate and a reload: the fresh load is what clears the choices held in component state.
  const reset = () => {
    clearSelections();
    setDone(true);
    window.location.replace(to || pathname);
  };

  return (
    <button
      type="button"
      onClick={reset}
      data-testid={testId}
      className={`mono inline-flex items-center gap-2 border border-white/20 px-4 py-2.5 text-[0.6rem] uppercase tracking-[0.16em] text-white transition-colors hover:border-ochre hover:text-ochre ${className}`}
    >
      <RotateCcw size={13} /> {done ? "Clearing…" : label}
    </button>
  );
};
